import { useTranslation } from 'react-i18next';
import I18N_RESOURCE from '@/i18n/template';

import CircularProgress from '../CircularProgress/CircularProgress';

export default function LoadingPage() {
  const { t } = useTranslation('dataSecurity');

  return (
    <div
    className="loading-page-root"
    style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: '#0063A3',
        margin: '7.5rem 0',
      }}
    >
      <CircularProgress size={40} />
      <p>
        {t('LOADING_PAGE.TITLE', {
          defaultValue: I18N_RESOURCE.LOADING_PAGE.TITLE,
        })}
      </p>
    </div>
  );
}
